// extracted by mini-css-extract-plugin
export var featureList = "index-module--featureList--afbc9";
export var icon = "index-module--icon--94b17";